import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootReducer'
import { unauthorizedMiddleware } from './middleWares/unauthorizedMiddleware'

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  }).concat(unauthorizedMiddleware)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store
